import html2canvas from "html2canvas";
import "../../css/Print.css";﻿

    var $printContainer = $('<div id="Print-container"></div>');

    class DefaultPrintOptions {
      constructor() {
        this.paperSize = "Letter"; //only Letter is implemented yet
        this.landscape = false;
        this.avoidLinks = true;
        this.margin = 30;
        this.multiPage = true;
        this.forcePageBreak = ".Print-pageBreak";
        this.scale = 0.8; //est-ce mieux de mettre 1 par défaut?
        this.customMapWidth = null;
        this.customMapHeight = null;
        Object.defineProperties(this, {
            "mapWidth" : {
                get : function() {
                    //full page width by default
                    return typeof this.customMapWidth == "number" ? this.customMapWidth : this.maxPageWidth;
                }
            },
            "mapHeight" : {
                get : function() {
                    //keep map proportion ("auto") by default (padding height by 15%)
                    return typeof this.customMapHeight == "number" ? this.customMapHeight : "auto";
                }
            },
            "maxPageWidth" : {
                get : function() {
                    // 1px = 1/72inch voir (https://docs.telerik.com/kendo-ui/framework/drawing/pdf-output#pdf-options)
                    // le scale ne doit pas faire partie de l'équation, car il s'applique au contenu et non aux dimensions de la page
                    return Math.floor((this.landscape ? 11 : 8.5)*72 - 2*this.margin);
                }
            },
            "maxPageHeight" : {
                get : function() {
                    // 1px = 1/72inch voir (https://docs.telerik.com/kendo-ui/framework/drawing/pdf-output#pdf-options)
                    // le scale ne doit pas faire partie de l'équation, car il s'applique au contenu et non aux dimensions de la page
                    return Math.floor((this.landscape ? 8.5 : 11)*72 - 2*this.margin);
                }
            }
        })
      }
    }

    export function exportToPDF(elemsToPrint, filename, printOptions) {
        printOptions = _.assign(new DefaultPrintOptions(), printOptions);
        Promise.all(_.map(elemsToPrint, _createPrintedElem.bind(this, printOptions)))
            .then(function($elements) {
                $("body").prepend($printContainer);
                _.forEach($elements, function($elem, idx) {
                    $printContainer.append($elem);
                    if ($elem && idx > 0) {
                        _addPageBreaks($elem, $(elemsToPrint[idx]), printOptions);
                    }
                });
                _createSavePDF(filename, printOptions);
            });
    };

    function _createPrintedElem(printOptions, elemToPrint, idx) {
        return new Promise(function(resolve, reject) {
            var $elemToPrint = $(elemToPrint),
                $elem = $('<div class="Print-elem">' +
                            ($elemToPrint.is("[print-prepend]") ? unescape($elemToPrint.attr("print-prepend")) : "") +
                            '<div class="Print-elem-content"></div>' +
                            ($elemToPrint.is("[print-append]") ? unescape($elemToPrint.attr("print-append")) : "") +
                        '</div>');

            if ($elemToPrint.is("[print-map]")) {
                $elem.find(".Print-elem-content").html('<div class="Print-canvasContainer" style="margin-top: 25px; text-align:center;"></div>');
                _mapToCanvas($elem, printOptions)
                    .then(function(canvas) {
                        $elem.find(".Print-canvasContainer").html(canvas);
                        resolve($elem);
                    });
            } else if ($elemToPrint.is("[print-SVG]")) {
                $elem.find(".Print-elem-content").html('<div class="Print-canvasContainer" style="margin-top: 25px; text-align:center;"></div>');
                _SVGToCanvas($elem, $elemToPrint.find("svg"), printOptions)
                    .then(function(canvas) {
                        $elem.find(".Print-canvasContainer").html(canvas);
                        resolve($elem);
                    });
            } else {
                $elem.find(".Print-elem-content").html(elemToPrint.innerHTML);
                resolve($elem);
            }
        });
    };

    function _mapToCanvas($elem, printOptions) {
          return html2canvas($(".cv-map")[0]).then(function(canvas){
            var printedCanvas = document.createElement("canvas"),
                context = printedCanvas.getContext("2d");
            printedCanvas.width = printOptions.mapWidth;
            printedCanvas.height = Math.floor(printOptions.mapHeight != "auto" ? printOptions.mapHeight : printedCanvas.width / canvas.width * canvas.height * 1.15);
            context.drawImage(canvas, (canvas.width - printedCanvas.width)/2 , (canvas.height - printedCanvas.height)/2, printedCanvas.width, printedCanvas.height, 0, 0, printedCanvas.width, printedCanvas.height);
            return printedCanvas;
          }.bind(this));
    };

    function _SVGToCanvas($elem, $svgElem, printOptions) {
        return new Promise(function(resolve, reject) {
            var svgElem = _getSVGWithInlineStyles($svgElem[0]),
                image = new Image($svgElem.width(), $svgElem.height());
            image.src = "data:image/svg+xml," + encodeURIComponent(new XMLSerializer().serializeToString(svgElem));
            image.onload = function() {
                var canvas = document.createElement("canvas"),
                    context = canvas.getContext("2d");
                canvas.width = image.width;
                canvas.height = image.height;
                context.drawImage(image, 0, 0);
                resolve(canvas);
            }
        });
    };

    function _getSVGWithInlineStyles(svgElem){
        //list of svg container elements tags
        var svgContainerElems = ["svg","g"];
        //list of css styles to apply inline per tags
        var svgStyles = {
            "rect": ["fill", "fill-opacity", "stroke", "stroke-width", "opacity"],
            "path": ["fill", "fill-opacity", "stroke", "stroke-width", "stroke-dasharray", "opacity"],
            "circle": ["fill", "fill-opacity", "stroke", "stroke-width", "opacity"],
            "line": ["stroke", "stroke-width", "stroke-dasharray", "visibility", "opacity"],
            "text": ["fill", "fill-opacity", "font-size", "text-anchor", "opacity"],
            "polygon": ["stroke", "fill", "fill-opacity", "opacity"]
        };

        function _setInlineStyles(svgElem) {
            var svgElemCopy = svgElem.cloneNode(true),
                childNodes = svgElem.childNodes,
                childNodesCopy = svgElemCopy.childNodes;
            _.forEach(childNodes, function(childNode, idx) {
                if (svgContainerElems.indexOf(childNode.tagName) != -1) {
                    _setInlineStyles(childNode);
                } else {
                    var styles = window.getComputedStyle(childNode);
                    var styleString = _.map(svgStyles[childNode.tagName], function(svgStyle) {
                        return svgStyle + ":" + styles.getPropertyValue(svgStyle) + ";";
                    }).join("");
                    childNode.setAttribute("style", styleString);
                }
            });
        };

        _setInlineStyles(svgElem);
        return svgElem;
    };

    function _addPageBreaks($elem, $elemToPrint, printOptions) {
        if ($elemToPrint.is("[print-forcePageBreak-before]") && !$elem.prev().hasClass("Print-pageBreak")) {
            $elem.before('<span class="Print-pageBreak"></span>');
        }
        if ($elemToPrint.is("[print-forcePageBreak-after]")) {
            $elem.after('<span class="Print-pageBreak"></span>');
        }
        //insert breaks before if $elem does not fit in the page (take scale into account)
        var currentPageHeight = ($printContainer.find("*").last().position().top + $printContainer.find("*").last().outerHeight(true)) - ($printContainer.find(".Print-pageBreak:last").length ? $printContainer.find(".Print-pageBreak:last").position().top : $printContainer.position().top);
        if (currentPageHeight*printOptions.scale >= printOptions.maxPageHeight && !$elem.prev().hasClass("Print-pageBreak")) {
            $elem.before('<span class="Print-pageBreak"></span>');
        }
    };

    function _createSavePDF(filename, printOptions) {
        kendo.drawing.drawDOM($printContainer, printOptions).then(function(group) {
            kendo.drawing.pdf.saveAs(group, filename + ".pdf");
            $printContainer.empty().remove();
        });
    };
